// extracted by mini-css-extract-plugin
export const page = "terms-and-conditions-module--page--2GR6P";